import { NextPageWithLayout } from "next";
import { ReactElement } from "react";

import calendarApi from "@/apis/calendar/calendarApi";
import {
  CalendarServiceType,
  DashboardChartData,
  DashboardData,
} from "@/apis/clients";
import dashboardApi from "@/apis/dashboard/dashboardApi";
import MyPageCalendar, {
  CalendarEvent,
  CalendarRange,
} from "@/components/organisms/mypage/MyPageCalendar";
import MyPageOverview from "@/components/organisms/mypage/MyPageOverview";
import { LayoutTemplate } from "@/components/templates/layout";
import { RewardNotice } from "@/features/referral/RewardNotice";
import { ReferralSummary } from "@/features/referral/ReferralSummary";
import { DateFormat, format } from "@/utils/date";

const title = "ホーム";

const MyPageTemplate: NextPageWithLayout = () => {
  const fetchDashboard = async (): Promise<DashboardData> => {
    const response = await dashboardApi.index();
    return response.data;
  };

  const fetchDashboardChart = async (
    start: Date,
    end: Date,
  ): Promise<DashboardChartData[]> => {
    const response = await dashboardApi.chart({
      fromMonth: format(start, DateFormat.yyyy_MM),
      toMonth: format(end, DateFormat.yyyy_MM),
    });
    return response.data;
  };

  const fetchCalendarEvents = async (
    range: CalendarRange,
    type?: CalendarServiceType,
  ): Promise<CalendarEvent[]> => {
    const response = await calendarApi.index({
      dateFrom: format(range.start, DateFormat.DEFAULT),
      dateTo: format(range.end, DateFormat.DEFAULT),
      type,
    });
    return response.data.map((s) => ({
      id: s.id,
      name: s.name,
      date: new Date(s.reservation_date),
      start: new Date(s.reservation_date),
      end: new Date(s.reservation_end_date),
      type: s.type,
      service_id: s.service_id,
      customer_name: s.customer_name,
    }));
  };

  return (
    <>
      <article className="space-y-10 md:space-y-16">
        {/* フェーズ1未対応のためコメントアウト */}
        {/* <section>
          <MyPageMenu />
        </section>
        <section>
          <EarningView />
        </section>
        <section>
          <OrderView />
        </section>
        <section>
          <AccessView />
        </section>
        <section>
          <ServiceView handleClickShow={handleClickService} />
        </section> */}

        <section>
          <RewardNotice surface="mypage" />
          <MyPageOverview
            getOverviewData={fetchDashboard}
            getChartData={fetchDashboardChart}
            afterShortcuts={<ReferralSummary />}
          />
        </section>

        {/* <section>
          <MyPageNotice />
        </section> */}

        <section className="-mx-4 md:mx-0">
          <MyPageCalendar getEvents={fetchCalendarEvents} />
        </section>
      </article>

      {/* <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=1217b21b-f6dd-4a45-b557-5dfa1fdb42b9"
      ></script>
      <script id="ze-snippet-settings" src="/user/zendesk.js"></script> */}
    </>
  );
};

export default MyPageTemplate;

MyPageTemplate.getLayout = function getLayout(children: ReactElement) {
  return <LayoutTemplate title={title}>{children}</LayoutTemplate>;
};
